module.exports = __webpack_public_path__ + "img/4_1.5371c8d1.png";